import type { PluginSimple } from 'markdown-it';

export const strikePlugin: PluginSimple = (md) => {
  md.use((md) => {
    md.inline.ruler.before('emphasis', 'custom_strike', (state, silent) => {
      const start = state.pos;
      if (state.src.slice(start, start + 2) !== '~~') return false;
      let match = start + 2;
      while ((match = state.src.indexOf('~~', match)) !== -1) {
        if (match > start + 2) {
          if (!silent) {
            const tokenOpen = state.push('strike_open', 'strike', 1);
            tokenOpen.level = state.level++;

            const tokenText = state.push('text', '', 0);
            tokenText.content = state.src.slice(start + 2, match);
            tokenText.level = state.level;

            const tokenClose = state.push('strike_close', 'strike', -1);
            tokenClose.level = --state.level;
          }
          state.pos = match + 2;
          return true;
        }
        match += 2;
      }
      return false;
    });

    md.renderer.rules.strike_open = () => '<strike>';
    md.renderer.rules.strike_close = () => '</strike>';
  });
};
